import { UseFieldArrayRemove } from 'react-hook-form';

import { Widget } from '@kanda-libs/ks-component-ts';

import { EXPENSE_PROPS, EXPENSE_SELECT_PROPS } from './constants';
import useExpenseItem from './useExpenseItem';

import IncomeExpenseWrapper from '../Wrapper';

export interface ExpenseItemProps {
  index: number;
  remove: UseFieldArrayRemove;
}

const ExpenseItem: React.FunctionComponent<ExpenseItemProps> = function ({
  index,
  remove,
}) {
  const { removeItem, selectValidation, amountValidation } = useExpenseItem(
    index,
    remove,
  );
  return (
    <IncomeExpenseWrapper remove={removeItem}>
      <div className="flex flex-row gap-x-3 md:gap-x-4">
        <Widget.CreditFinanceDetailsExpendituresExpenditureTypeArraySelect
          index={index}
          {...EXPENSE_SELECT_PROPS}
          validation={selectValidation}
        />
        <Widget.CreditFinanceDetailsExpendituresMonthlyAmountAmountArrayInput
          index={index}
          {...EXPENSE_PROPS}
          validation={amountValidation}
        />
      </div>
    </IncomeExpenseWrapper>
  );
};

export default ExpenseItem;
